import { getUrlParamsFetch } from "../utils";

// Resultado estándar del fetch para el autocomplete
export type FetchResult<TOption> = {
  options: TOption[];
  hasMore: boolean;
};

type FetchFn<TOption> = (url: string) => Promise<FetchResult<TOption>>;

interface GenericFetchArgs<
  TOption,
  TParams extends Record<string, any>,
  TKey extends string
> {
  baseUrl: string;           // ej: `${urlBackend}api/v1/ubicacion/`
  fetchFn: FetchFn<TOption>; // ej: (url) => fetchAutocompleteGeneric(...)
  allOption?: TOption;       // ej: OPCION_TODOS_UBICACION
  search: string;
  page: number;
  isAll: boolean;
  keySearch: TKey;           // ej: 'codigo'
  params: TParams;           // ej: UbicacionesParams
}

export async function genericFetch<
  TOption,
  TParams extends Record<string, any>,
  TKey extends string
>(
  args: GenericFetchArgs<TOption, TParams, TKey>
): Promise<FetchResult<TOption>> {
  const {
    baseUrl,
    fetchFn,
    allOption,
    search,
    page,
    isAll,
    keySearch,
    params,
  } = args;

  const query = getUrlParamsFetch({
    estado: true,
    [keySearch]: search,
    page,
    ...params,
  });

  const res = await fetchFn(`${baseUrl}?${query}`);
  const { options, hasMore } = res;

  const newOptions =
    page === 1 && isAll && allOption
      ? [allOption, ...options]
      : options;

  return {
    options: newOptions,
    hasMore,
  };
}
